import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);

export default new Router({
  mode: 'history',
  // routes:routes,
  // base: process.env.BASE_URL,
  base: '/',
  routes: [
    {
      path: '/',
      component: () =>import('@/pages/home')
    },
    {
      path: '/SearchList',
      component: () =>import('@/pages/search-list/SearchList'),
      name: '产品名录结果',
      meta: { title: "产品名录结果" },
    },
    {
      path: '/ShoppingCart',
      component: () =>import('@/pages/shopping-cart/ShoppingCart')
    },
    {
      path: '/ShoppingOrder',
      component: () =>import('@/pages/shopping-order/ShoppingOrder')
    },
    {
      path: '/payGateWay',
      component: () =>import('@/pages/shopping-order/payGateWay')
    },
    {
      path: '/ShoppingCompleted',
      component: () =>import('@/pages/shopping-completed/ShoppingCompleted')
    },
    {
      path: '/ShoppingWait',
      component: () =>import('@/pages/shopping-order/ShoppingWait')
    },
    {
      path: '/clause',
      component: () =>import('@/pages/clause/clause')
    },
    {
      path: '/guide',
      component: () =>import('@/pages/clause/guide')
    },
    {
      path: '/page',
      component: () =>import('@/pages/page/index'),
      name: "page",
      // redirect: '@/pages/page/table',
      children: [
        {
          path: '/table',
          component: () =>import('@/pages/page/dataTable'),
          name: 'tablePage'
        },
        {
          path: '/table2',
          component: () =>import('@/pages/page/dataTable2'),
        },
        {
          path: '/download',
          component: () =>import('@/pages/page/download'),
          name: "download"
        }
      ]
    },
    {
      path: '/Personal',
      component: () =>import('@/pages/personal/Personal'),
      name: '个人中心',
      meta: { title: "个人中心" ,
              requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      },
      redirect: '/PersonalInfo',
      children: [
        {
          path: '/PersonalInfo',
          component: () =>import('@/pages/personal/PersonalInfo'),
          name: '个人信息',
          meta: { title: "个人信息",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
             }
        },
        {
          path: '/PersonalService',
          component: () =>import('@/pages/personal/PersonalService'),
         // name: '服务项目',
          //meta: { title: "服务项目" ,
          name: '服务指南',
          meta: { title: "服务指南" ,
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/PersonalBkService',
          component: () =>import('@/pages/personal/PersonalBkService'),
          name: '包库管理',
          meta: { title: "包库管理" ,
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        // {
        //   path: '/Personal/PersonalBrowse',
        //   component: ()=>import('@/pages/personal/PersonalBrowse'),
        //   name:'服务项目',
        //   meta:{title:"服务项目"}
        // },
        {
          path: '/PersonalIntegral',
          component: () =>import('@/pages/personal/PersonalIntegral'),
          name: '积分管理',
          meta: { title: "积分管理",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/PersonalOrder',
          component: () =>import('@/pages/personal/PersonalOrder'),
          name: '我的订单',
          meta: { title: "我的订单",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/PersonalControl',
          component: () =>import('@/pages/personal/PersonalControl'),
          name: '发票管理',
          meta: { title: "发票管理",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/PersonalContract',
          component: () =>import('@/pages/personal/PersonalContract'),
          name: '合同管理',
          meta: { title: "合同管理",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/PersonalAccount',
          component: () =>import('@/pages/personal/PersonalAccount'),
          name: '子账号管理',
          meta: { title: "子账号管理",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/PersonalSystem',
          component: () =>import('@/pages/personal/PersonalSystem'),
          name: '消息管理',
          meta: { title: "消息管理",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/PersonalSystemDel',
          component: () =>import('@/pages/personal/PersonalSystemDel'),
          name: '消息详情管理',
          meta: { title: "消息详情管理",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        }
      ]
    },
    {
      path: '/login',
      component: () =>import('@/pages/login')
    },
    {
      path: '/qclink',
      component: () =>import('@/pages/qclink')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js